import React, { useState, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import updateRA from 'immutability-helper'

import {
  fromC,
} from 'altrac-conversions'
import styles from '../../../../../css/settings.module.css'
import Arrow from '../../Graphics/Arrow'

import AppDispatcher from '../../../../dispatchers/AppDispatcher'
import AppStore from '../../../../stores/AppStore'

function SettingHistorySimple (props) {
  const { object, item } = props
  const {
    locale: { tempConv },
  } = AppStore.getUser()

  let title
  let itemValue

  if (item === 'tempStart') {
    title = 'Start Temp'
    itemValue = fromC(object.settings[item], tempConv, 1)
  } else if (item === 'tempStop') {
    title = 'Stop Temp'
    itemValue = fromC(object.settings[item], tempConv, 1)
  } else if (item === 'auto') {
    title = 'Controller State'
    itemValue = object.settings[item]
    if (itemValue === 1) {
      itemValue = 'Auto'
    } else {
      itemValue = 'Manual'
    }
  } else if (item === 'run') {
    title = 'Machine State'
    itemValue = object.settings[item]
    if (itemValue === 1) {
      itemValue = 'On'
    } else {
      itemValue = 'Off'
    }
  } else if (item === 'sleepInterval') {
    title = 'Sleep Interval'
    itemValue = object.settings[item]
  } else if (item === 'speed') {
    title = 'RPM Target'
    itemValue = object.settings[item]
  }
  if (title && itemValue) {
    return (
      <div>
        {title}
        :
        {itemValue}
      </div>
    )
  }
  return ''
}

function SettingInfo (props) {
  const { object } = props

  let UserInfo = null
  let UserEmail = false
  let currentStatus = object.status

  if (currentStatus === 'onDevice') {
    currentStatus = 'Delivered'
  } else if (currentStatus === 'new') {
    currentStatus = 'Queued'
  } else if (currentStatus === 'error') {
    currentStatus = 'Error'
  }
  if (
    object.user &&
    object.user.email &&
    typeof object.user.email === 'string'
  ) {
    UserEmail = object.user.email.includes('@altrac')
  }
  if (
    object.user &&
    object.user.first_name !== '' &&
    object.user.first_name !== null &&
    !UserEmail
  ) {
    const fullName = `${object.user.first_name} ${object.user.last_name}`
    UserInfo = fullName
  } else if (
    object.user &&
    object.user.name !== '' &&
    object.user.name !== null &&
    !UserEmail
  ) {
    UserInfo = object.user.name
  } else if (
    object.user &&
    (object.user.name === '' || object.user.name === null) &&
    !UserEmail
  ) {
    UserInfo = object.user.email
  } else if (UserEmail && currentStatus === 'Delivered') {
    UserInfo = 'Altrac Server'
  } else if (UserEmail) {
    UserInfo = 'Altrac Support'
  }

  return (
    <div className={styles.dataListItemContainer}>
      <div className={styles.dataListHeaderWrapper}>
        <p className={styles.dataListHeaderDate}>Time</p>
        <p className={styles.dataListHeaderSetting}>Changed Setting</p>
      </div>
      <div className={styles.dataListItem}>
        <div className={styles.dataListDate}>
          <div className={styles.accordionDate}>
            <p>{moment(object.updated_at).format('l')}</p>
            <p>{moment(object.updated_at).format('LTS')}</p>
          </div>
        </div>
        <div className={styles.dataListInfo}>
          {Object.keys(object.settings).map((item) => (
            <div key={item}>
              <SettingHistorySimple object={object} item={item} />
            </div>
          ))}
        </div>
      </div>
      <div className={`${styles.dataListWrapperInside} ${styles.isOpen}`}>
        <div className={styles.dataListTitleWrapperInside}>
          <div className={styles.dateTitleInside}>
            <p>State</p>
          </div>
          <div className={styles.infoTitleInside}>User</div>
        </div>
        <div className={styles.dataListItemInside}>
          <div className={styles.dataListDateInside}>
            <p>{currentStatus}</p>
          </div>
          <div className={styles.dataListUserInside}>
            {object.user ? UserInfo : 'API User'}
          </div>
        </div>
      </div>
    </div>
  )
}

function DataList (props) {
  const {
    data, settingHistoryReady, getMoreData, totalEntries, limit,
  } = props
  // const disableMoreButton = parseInt(totalEntries, 10) <= parseInt(limit, 10)

  if (settingHistoryReady) {
    const { entries } = data
    return (
      <div className={`${styles.inputArea} ${styles.noPadding}`}>
        <div className=''>
          {entries
            .sort(
              (a, b) => new Date(b.updated_at).getTime() -
                  new Date(a.updated_at).getTime()
            )
            .map((object, index) => (
              <React.Fragment key={index}>
                <SettingInfo object={object} />
              </React.Fragment>
            ))}
        </div>
        <div
          className={`${styles.moreButtonDataList}`}
          onClick={getMoreData()}
          role='button'
          tabIndex={0}
        >
          <h4>See more</h4>
          <Arrow />
        </div>
      </div>
    )
  }
  return null
}

function SettingHistoryMain ({ deviceID, data, settingHistoryReady }) {
  const { total_count: totalCount } = data

  const [state, setState] = useState({
    offset: 0,
    limit: 5,
    totalEntries: totalCount,
    timeBeg: '',
    timeEnd: '',
  })

  const getNewData = useCallback(() => {
    setState((currentState) => {
      const {
        offset, limit, timeBeg, timeEnd,
      } = currentState

      AppDispatcher.dispatch({
        action: 'get-setting-history',
        deviceID,
        offset,
        limit,
        timeBeg,
        timeEnd,
      })

      return currentState
    })
  }, [deviceID])

  const getMoreData = useCallback(
    () => (e) => {
      if (e) {
        e.preventDefault()
      }
      setState((prevState) => {
        const newLimit = prevState.limit + 5
        return { ...prevState, limit: newLimit }
      })
      return false
    },
    []
  )

  const childChange = useCallback(
    (event) => {
      const {
        target: { name, value },
      } = event
      let newValue = value

      switch (name) {
        case 'periodStart':
          newValue = value
          break
        case 'periodStop':
          newValue = value
          break

        default:
          return
      }

      setState((currentState) => {
        let newState = updateRA(currentState, {
          [name]: { $set: newValue },
        })

        if (name === 'periodStart') {
          const periodStart = moment(value).utc().toISOString()
          newState = updateRA(newState, {
            timeBeg: { $set: periodStart },
          })
        } else if (name === 'periodStop') {
          const periodStop = moment(value).utc().toISOString()
          newState = updateRA(newState, {
            timeEnd: { $set: periodStop },
          })
        }

        return newState
      })
    },
    []
  )

  // Update totalEntries when data changes (separate from getNewData to avoid loops)
  useEffect(() => {
    if (settingHistoryReady && data.total_count !== undefined) {
      const { limit: currentLimit, total_count: totalCount } = data
      setState((prevState) => {
        if (prevState.totalEntries !== totalCount && currentLimit !== prevState.limit) {
          return { ...prevState, totalEntries: totalCount }
        }
        return prevState
      })
    }
  }, [data.total_count, data.limit, settingHistoryReady])

  // Initial load and periodic refresh
  useEffect(() => {
    getNewData()
    const interval = setInterval(getNewData, 60000)

    return () => {
      clearInterval(interval)
    }
  }, [getNewData])

  // Trigger getNewData when limit changes
  useEffect(() => {
    if (state.limit > 5) {
      // Only call if limit has been increased from initial value
      getNewData()
    }
  }, [state.limit, getNewData])

  // Trigger getNewData when time filters change
  useEffect(() => {
    if (state.timeBeg || state.timeEnd) {
      getNewData()
    }
  }, [state.timeBeg, state.timeEnd, getNewData])

  return (
    <DataList
      data={data}
      settingHistoryReady={settingHistoryReady}
      getMoreData={getMoreData}
      totalEntries={state.totalEntries}
      limit={state.limit}
    />
  )
}

SettingHistoryMain.propTypes = {
  deviceID: PropTypes.string,
  settingHistoryReady: PropTypes.bool,
  data: PropTypes.object.isRequired,
}

export default SettingHistoryMain
